export const PATH = "ept.json";

export enum DataIndexActionType {
    Delete = "delete",
    Opacity = "opacity",
    Attribute = "attribute",
    Intensity = "intensity",
    Edit = "edit",
    Hide = "hide",
    Show = "show",
    ZoomTo = "zoomto",
    Translation = "translation",
    Reload = "reload",
    Share = "share",
}

export enum IntersectType {
    Volumn = "volumn",
    Polygon = "polygon"
}

export enum ConversionStatus {
    Uploading = "uploading",
    Uploaded = "uploaded",
    Built = "built",
    Converted = "converted",
    Normal = ""
}

export enum DownloadItemStatus {
    Done = "done",
    Processing = "processing",
    Error = "Error",
    Unknown = "unknown",
    downloaded = "downloaded"
}

export enum AOIIndexActionType {
    ZoomTo = "zoomto",
    OpenModal = "openmodal",
    OpenProcessingModal = "openProcessingModal",
    Show = "show",
    Hide = "hide",
}
